// services/CandidateStorage.ts
export const CandidateStorage = {
  /** Persist the candidate’s numeric ID */
  save(id: number) {
    localStorage.setItem("candidate_id", String(id));
  },
  /** Retrieve the ID (or null if not set) */
  get(): number | null {
    const raw = localStorage.getItem("candidate_id");
    return raw !== null ? Number(raw) : null;
  },
  /** Remove the ID from storage */
  clear() {
    localStorage.removeItem("candidate_id");
  },
};

export const openContractForm = () => {
  window.open("/contract_form.pdf", "_blank"); // Open the contract form from the public folder
}